import BaseClass from "../util/BaseClass";
import Dnd from "../spaceplanner/base/Dnd"
import Context from "./Context";
import Planner from "../spaceplanner/base/Planner";
import * as val from "../util/val";

export default class AppMode extends BaseClass {

  appType = "indoors";
  mapDivId = "view-container";

  _appTypeKeyword = "IndoorsApp";
  _requiresImmediateAuthentication = false;
  _supports3D = true;
  _supportsBasemapGallery = true;
  _supportsCategories = true;
  _supportsHome = true;
  _supportsInfoPanel = true;
  _supportsMyPlaces = true;

  getAppTypeKeyword() {
    return (this._appTypeKeyword);
  }

  init() {
    let urlAppType = val.getUrlParamValue("apptype");
    let appType = urlAppType || Context.instance.config.appType;

    if (appType === "indoors-spaceplanner") {
      this.appType = "indoors-spaceplanner";
      this.mapDivId = "sp-view-container";
      this._appTypeKeyword = "IndoorsSpaceplannerApp";
      this._requiresImmediateAuthentication = true;
      this._supports3D = false;
      this._supportsBasemapGallery = false;
      this._supportsCategories = false;
      this._supportsHome = false;
      this._supportsInfoPanel = false;
      this._supportsMyPlaces = false;
      Context.instance.config.highlightFacilityOnHover2D = false;
      Context.instance.spaceplanner.planner = new Planner();
      Context.instance.spaceplanner.dnd = new Dnd();
    } else {
      this.appType = "indoors";
      this._appTypeKeyword = "IndoorsApp";
      this._requiresImmediateAuthentication = false;
      this._supports3D = true;
      this._supportsBasemapGallery = true;
      this._supportsCategories = true;
      this._supportsHome = true;
      this._supportsInfoPanel= true;
      this._supportsMyPlaces = true;
    }
  }

  isSpacePlanner() {
    return (this.appType === "indoors-spaceplanner");
  }

  requiresImmediateAuthentication() {
    return this._requiresImmediateAuthentication;
  }

  supports3D() {
    return this._supportsHome;
  }

  supportsBasemapGallery() {
    return this._supportsBasemapGallery;
  }

  supportsCategories() {
    return this._supportsCategories;
  }

  supportsHome() {
    return this._supportsHome;
  }

  supportsInfoPanel() {
    return this._supportsInfoPanel;
  }

  supportsMyPlaces() {
    return this._supportsMyPlaces;
  }

}
